import { Injectable, inject } from "@angular/core";
import { IgxGridCell } from "@infragistics/igniteui-angular";
import { IgxGridComponent } from '@infragistics/igniteui-angular/grids/grid';
import { Utilities } from "@tylertech/shared-module";
import { MetadataService, ProviderStorageService } from "../../services";

interface CellState
{
    isDisabled: boolean;
    getIcon?: string;
    useIconSpan?: boolean;
    isHidden?: boolean;
}

@Injectable({ providedIn: "root" })
export class GridCellStateService
{
    private readonly $metadataService = inject(MetadataService);
    private readonly $providerStorageService = inject(ProviderStorageService);

    private _cellStates: Map<string, Map<string, CellState>> = new Map();


    computeAllCellStates(providerId: string, grid: IgxGridComponent, columns: any[]): void
    {
        const self = this;

        if (!self._cellStates.has(providerId))
            self._cellStates.set(providerId, new Map<string, CellState>());

        const fromScroll = this.$providerStorageService.Scrolling[providerId];
        if (!fromScroll)
            self._cellStates.get(providerId).clear();

        const cellStates = self._cellStates.get(providerId);

        grid.allRows().filter(x => x !== undefined)
            .forEach((row, index) =>
            {
                const model = row.data["$$model"];
                columns.forEach(column =>
                {
                    const key = `${row.index}_${column.Name}`;
                    if (!cellStates.has(key))
                    {
                        const action = column.MetadataAction ?? column.LinkAction ?? null;
                        const hasGridData = !Utilities.IsNullOrUndefined(this.$providerStorageService.GridData[providerId]);

                        cellStates.set(key, {
                            getIcon: setGetIcon(model, column),
                            useIconSpan: setUseIconSpan(column),
                            isDisabled: !!action && hasGridData && this.$metadataService.GetPermissionDenied(action.Disabled, action.DisabledProperty, model),
                            isHidden: !!action && hasGridData && this.$metadataService.GetPermissionDenied(action.Hidden, action.HiddenProperty, model)
                        });
                    }
                });
            });

        function setGetIcon(model: any, column: any): string
        {
            if (!column?.Icon)
                return null;
            return self.$metadataService.EvaluateString(column.Icon, null, model);
        }

        function setUseIconSpan(column: any): boolean
        {
            return column.Icon ? column.Icon.startsWith("icon-") : false;
        }
    }

    getCellState(cell: IgxGridCell): CellState | undefined
    {
        const key = `${cell.id.rowIndex}_${cell.column.field}`;
        return this._cellStates.get(cell.grid.id)?.get(key);
    }
}
